import React, { useContext, useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { GetAvailableCouponList } from '../ApiServices/CouponCode/CouponCodeApi';
import { LoaderContext } from '../AuthContext/AuthContext';
import couponImage from '../assets/images/new/coupon.png'


const CouponModal = ({ show, handleClose, modelRequestData, setAppliedCoupon, apiParam, setIsWalletApplied }) => {
  const [couponInput, setCouponInput] = useState('');
  const [expandedId, setExpandedId] = useState(null);
  const [couponList, setCouponList] = useState([])
  const userID = localStorage.getItem("userID");
  const { setLoader } = useContext(LoaderContext);

  const toggleExpand = (id) => {
    setExpandedId(prev => prev === id ? null : id);
  };

  useEffect(() => {
    if (show) {
      GetAvailableCouponListData()
    }

  }, [show])
  const GetAvailableCouponListData = async () => {
    setLoader(true);
    try {
      let response = await GetAvailableCouponList(apiParam); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        setCouponList(list)

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const handleApplyClicked = (coupon) => {
    setIsWalletApplied(false)
    setCouponInput(coupon?.CouponCode)
    setAppliedCoupon((prev) => ({ ...prev, CouponCode: coupon?.CouponCode, isApplied: true, CoupenAmount: coupon?.CoupenAmount, couponCodeID: coupon?.CouponCodeID }))
    handleClose()
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>Apply Coupons</Modal.Title>
      </Modal.Header>
      <Modal.Body >
        {couponList?.length > 0 ? (
          <>
            <div style={{ height: '20em', width: '100%', overflowY: 'scroll' }}>

              <h6 className="mb-3">Available Coupons</h6>
              {couponList.map((coupon) => (
                <div
                  key={coupon.CouponCodeID}
                  className="coupon-card mb-3 p-3 rounded shadow-sm"
                  style={{
                    border: "1px solid #ccc", // Full border
                    borderLeft: "6px solid #a52444", // Highlighted left border
                    background: "#fff",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                  }}
                >
                  <div className="row align-items-center">
                    {/* Icon - 20% */}
                    <div className="col-12 col-md-2 d-flex justify-content-center justify-content-md-start mb-2 mb-md-0">
                      <img
                        src={couponImage}
                        width={36}
                        height={36}
                        alt="Coupon"
                        style={{ flexShrink: 0 }}
                      />
                    </div>

                    {/* Code + Description - 60% */}
                    <div className="col-12 col-md-8">
                      <div
                        className="fw-bold text-dark px-2 py-1 mb-1"
                        style={{
                          display: "inline-block",
                          border: "2px dotted grey",
                          borderRadius: "4px",
                          fontSize: "14px",
                        }}
                      >
                        {coupon.CouponCode}
                      </div>
                      <p
                        className="text-muted mb-0"
                        style={{ fontSize: "13.5px", lineHeight: "1.4" }}
                      >
                        {coupon.Description}
                      </p>
                    </div>

                    {/* Apply Button - 20% */}
                    <div className="col-12 col-md-2 mt-2 mt-md-0 d-flex justify-content-md-end">
                      <button
                        className="btn btn-sm w-100 w-md-auto text-white px-3 py-1"
                        style={{
                          background: "linear-gradient(90deg, #a52444, #f18d9e)",
                          fontWeight: "500",
                          fontSize: "13px",
                        }}
                        onClick={() => handleApplyClicked(coupon)}
                      >
                        APPLY
                      </button>
                    </div>
                  </div>
                </div>
              ))}



            </div>
          </>
        ) : <div >
          <h5 className='text-center'>No Coupons Available</h5>
        </div>}

      </Modal.Body>
    </Modal>

  );
};

export default CouponModal;
